let workOrderVisibilityGeneration = 0;

export function getWorkOrderVisibilityGeneration(): number {
  return workOrderVisibilityGeneration;
}

export function advanceWorkOrderVisibilityGeneration(): number {
  workOrderVisibilityGeneration += 1;
  return workOrderVisibilityGeneration;
}

export function isCurrentWorkOrderVisibilityGeneration(
  generation: number
): boolean {
  return generation === workOrderVisibilityGeneration;
}
